import styled from 'styled-components';

const TextContainer  =styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 30px;
`;

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    button {
        height: 36px;
        width: 117px;
        box-shadow: none;
        padding: 0;
        min-height: 20px;
        min-width: 100px;
        font-size: 14px;
    }
`
const GradientWrapper = styled.div`
    height: 100%;
    width: 100%;
    background: ${props => props.color};
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
        height: 70px;
    }

    label {
        color: white;
        text-align: center;
    }
`

const TitleWrapper  = styled.div`
    font-size: 24px;
    margin: 56px 66px 0px 66px;
    font-weight: bold;
    line-height: 29px;
`



export { TextContainer, ButtonContainer,GradientWrapper , TitleWrapper}